import React, { useState } from "react";
import { MapPin, Heart, Expand } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { PhotoLightbox } from "./PhotoLightbox";

export const DetailGallery = ({ gallery, title, fav, onToggleFav }) => {
  const [openIdx, setOpenIdx] = useState(null);
  const open = (i) => setOpenIdx(i);
  return (
    <>
      <div className="relative overflow-hidden rounded-3xl">
        {gallery.length > 1 ? (
          <Carousel className="w-full">
            <CarouselContent>
              {gallery.map((g, i) => (
                <CarouselItem key={i}>
                  <button
                    type="button"
                    onClick={() => open(i)}
                    data-testid={`gallery-photo-${i}`}
                    className="aspect-[16/10] w-full cursor-zoom-in bg-slate-100"
                    aria-label={`Open foto ${i + 1} op volledig scherm`}
                  >
                    <img src={g} alt={`${title} ${i + 1}`} className="h-full w-full object-cover" />
                  </button>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="left-4" />
            <CarouselNext className="right-4" />
          </Carousel>
        ) : (
          <div className="aspect-[16/10] w-full bg-slate-100">
            {gallery[0] ? (
              <button
                type="button"
                onClick={() => open(0)}
                data-testid="gallery-photo-0"
                className="h-full w-full cursor-zoom-in"
                aria-label="Open foto op volledig scherm"
              >
                <img src={gallery[0]} alt={title} className="h-full w-full object-cover" />
              </button>
            ) : (
              <div className="flex h-full items-center justify-center text-slate-300">
                <MapPin size={48} />
              </div>
            )}
          </div>
        )}
        {gallery.length > 0 && (
          <button
            type="button"
            onClick={() => open(0)}
            data-testid="gallery-expand"
            className="absolute bottom-4 right-4 z-10 flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-xs font-bold text-navy shadow-md transition hover:bg-white"
          >
            <Expand size={14} /> Alle foto&apos;s ({gallery.length})
          </button>
        )}
        <button
          onClick={onToggleFav}
          data-testid="detail-favorite"
          className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-white/90 shadow-md transition-transform hover:scale-105"
          aria-label="favorite"
        >
          <Heart size={20} className={fav ? "fill-danger text-danger" : "text-slate-500"} />
        </button>
      </div>
      <PhotoLightbox
        gallery={gallery}
        index={openIdx}
        title={title}
        onClose={() => setOpenIdx(null)}
        onChange={setOpenIdx}
      />
    </>
  );
};
